export default {
  metrics: {
    pickup: 'Ridicare',
    internal_delivery: 'Livrare internă',
    external_delivery: 'Livrare externă',
  },
  events: {
    add_to_basket: 'Adaugă articol',
    begin_checkout: 'Continuă la plată',
    begin_purchase: 'Inițiază plata',
    complete_purchase: 'Finalizează plata',
    order_placed: 'Finalizează plata',
    view_item: 'Vezi articolul',
  },
};
